import { useRef, useEffect, useState } from "react";
import { useUser } from "../../contexts/UserContext";
import postService from "../../services/post-service";
import PostContent from "../../types/post-type";

export const usePostFunctions = () => {
  const [publicPosts, setPublicPosts] = useState<PostContent[]>([]);
  const [privatePosts, setPrivatePosts] = useState<PostContent[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [visibility, setVisibility] = useState<"public" | "private">("private");
  const { user, userId, userRole } = useUser();

  const userIdRef = useRef(userId);

  const fetchPosts = async () => {
    setIsLoading(true);
    try {
      const publicPostsResponse = await postService.getPublicPosts();
      if (publicPostsResponse) {
        setPublicPosts(publicPostsResponse.data);
      }

      if (userIdRef) {
        const privatePostsResponse = await postService.getPrivatePosts();
        if (privatePostsResponse) {
          setPrivatePosts(privatePostsResponse.data);
        }
      }
    } catch (error) {
      console.error("Error fetching posts", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePostDelete = (post: PostContent) => {
    if (!post.id) {
      console.error("Post ID is undefined");
      return;
    }
    if (
      user &&
      (post.creatorId === userId ||
        userRole.includes("admin") ||
        userRole.includes("moderator"))
    )
      if (post.visibility === "public") {
        postService.deletePost(post.id, post.visibility).then(
          () => {
            const updatedPosts = publicPosts.filter(
              (currentPost) => currentPost.id !== post.id
            );
            setPublicPosts(updatedPosts);
          },
          (error) => {
            console.error(
              "You are trying to delete another users post or you are lacking privilages",
              error
            );
          }
        );
      } else if (post.visibility === "private") {
        postService.deletePost(post.id, post.visibility).then(
          () => {
            const updatedPosts = privatePosts.filter(
              (currentPost) => currentPost.id !== post.id
            );
            setPrivatePosts(updatedPosts);
          },
          (error) => {
            console.error(
              "You are trying to delete another users post or you are lacking privilages",
              error
            );
          }
        );
      }
  };

  useEffect (() =>{
    userIdRef.current = userId;
    console.log("Fetching posts!")
    fetchPosts();
  }, [userId])

  return {
    publicPosts,
    privatePosts,
    isLoading,
    visibility,
    fetchPosts,
    setPrivatePosts,
    setPublicPosts,
    setVisibility,
    handlePostDelete,
  };
};
